"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sendMessage = exports.PreviewMessageType = void 0;

var validation_1 = require("../../validation");

var PreviewMessageType;

(function (PreviewMessageType) {
  PreviewMessageType["READY"] = "ready";
  PreviewMessageType["LOAD"] = "load";
  PreviewMessageType["ERROR"] = "error";
  PreviewMessageType["UPDATE"] = "update";
  PreviewMessageType["CONTROLLER_REQUEST"] = "controller_request";
  PreviewMessageType["CONTROLLER_RESPONSE"] = "controller_response";
  PreviewMessageType["EMOTE_EVENT"] = "emote_event";
})(PreviewMessageType = exports.PreviewMessageType || (exports.PreviewMessageType = {}));
/** @alpha */


(function (PreviewMessageType) {
  PreviewMessageType.schema = {
    type: 'string',
    enum: Object.values(PreviewMessageType)
  };
  PreviewMessageType.validate = (0, validation_1.generateLazyValidator)(PreviewMessageType.schema);
})(PreviewMessageType = exports.PreviewMessageType || (exports.PreviewMessageType = {}));

var sendMessage = function sendMessage(window, type, payload) {
  var targetOrigin = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '*';
  var event = {
    type: type,
    payload: payload
  };
  window.postMessage(event, targetOrigin);
};

exports.sendMessage = sendMessage;